import React, { useMemo, useRef, useState } from "react";
import { Carousel, Image } from "antd";
import { EyeOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";

const CustomImage = ({ src }) => {
  const [preview, setPreview] = useState(false);

  return (
    <>
      <div className="image-cont">
        <div style={{ backgroundImage: `url('${src}')` }} className="image" />
        <div className="skin" onClick={() => setPreview(true)}>
          <div className="preview">
            <div>
              <EyeOutlined />
              <label>Preview</label>
            </div>
          </div>
        </div>
      </div>
      <Image
        preview={{ src, visible: preview, onVisibleChange: (v) => setPreview(v) }}
      />
    </>
  );
}

const Gallery = ({ images, t }) => {
  const ref = useRef();
  const [slide, setSlide] = useState(0);

  const goTo = (slide) => {
    ref.current.goTo(slide, false);
  };

  const urls = useMemo(() => {
    if (images && Array.isArray(images)) {
      return images.map((f) => {
        if (f.url) {
          return {
            url: f.url,
            sourceName: f.sourceName,
          };
        }
        if (f.response && f.response.url) {
          return {
            url: f.response.url,
            sourceName: f.sourceName,
          };
        }
        return '';
      });
    }
    return null;
  }, [images]);

  const afterChange = (index) => {
    setSlide(index);
  };

  return urls && Array.isArray(urls) && urls.length ? (
    <div className="cont gallery">
      <div className="header">
        <label>{t('Gallery')}</label>
        <div className="controller">
          {slide !== 0 && (
            <LeftOutlined onClick={() => goTo(slide - 1)} className="go-left text-light-blue" />
          )}
          <span>{t('Viewing')} {slide + 1} {t('of')} {urls.length}</span>
          {slide !== urls.length - 1 && (
            <RightOutlined onClick={() => goTo(slide + 1)} className="go-right text-light-blue" />
          )}
        </div>
      </div>
      <Carousel
        ref={ref}
        afterChange={afterChange}
      >
        {urls.map((img, i) => (
          <div key={i.toString()}>
            <CustomImage src={img.url} sourceName={img.sourceName} />
          </div>
        ))}
      </Carousel>
      {(urls[slide] && urls[slide].sourceName) && (
        <div className="information-by">
          <label>&#169; Image by {urls[slide].sourceName}</label>
        </div>
      )}
    </div>
  ) : null;
};

export default Gallery;
